{
  "promotion": {
    "bookingConfirmation": {
      "title": "Trip booked. Thank you!",
      "content": "<p>We’ve sent the confirmation and separate e-ticket to <b>{email}</b>.</p><p>Haven't arrived within 24 hours? Please contact our customer service.</p><p>You can now view and manage your trip and explore hotel or car rental options on this page.</p>",
      "buttonText": "How did booking go?"
    },
    "checkedInBaggage": {
      "genericBaggageType": "Baggage",
      "numberedBaggageTitle": "{bagNumber}. {baggageType}",
      "baggageWeight": "{weight} kg"
    }
  },
  "subHeader": {
    "backToMyBookings": "Exit trip",
    "backToMyBookingsAria": "Exit trip"
  },
  "includedProducts": {
    "seatWifi": {
      "text": "{displayName}"
    },
    "seatFreshMeal": {
      "text": "{displayName}"
    },
    "seatHotPreOrderMeal": {
      "text": "{displayName}"
    },
    "seatCabinBaggage": {
      "text": "{displayName}"
    },
    "seatPriorityServices": {
      "text": "{displayName}"
    },
    "loungePriority": {
      "title": "Lounge + Priority combo"
    },
    "loungePriorityServices": {
      "text": "{displayName}"
    },
    "loungeCabinBaggage": {
      "title": "Lounge + Carry-on combo",
      "text": "{displayName}"
    },
    "loungeWifi": {
      "title": "Lounge + Internet combo",
      "text": "{displayName}"
    },
    "wifiMeal": {
      "title": "Internet + Meal combo"
    },
    "wifiFreshMeal": {
      "text": "{displayName}"
    },
    "wifiHotPreOrderMeal": {
      "text": "{displayName}"
    }
  },
  "services": {
    "seatWifi": {
      "paid": "{amount} x Seat + Internet"
    },
    "seatMeal": {
      "paid": "{amount} x Seat + Meal"
    },
    "seatPriority": {
      "paid": "{amount} x Seat + Priority"
    },
    "seatCabinBaggage": {
      "paid": "{amount} x Seat + Carry-on"
    },
    "loungePriority": {
      "paid": "{amount} x Lounge + Priority"
    },
    "loungeWifi": {
      "paid": "{amount} x Lounge + Internet"
    },
    "loungeCabinBaggage": {
      "paid": "{amount} x Lounge + Carry-on"
    },
    "wifiMeal": {
      "paid": "{amount} x Internet + Meal"
    }
  },
  "voluntaryChange": {
    "phases": {
      "checkPrices": {
        "loaderText": "Just a moment, we are fetching your options",
        "disclaimer": {
          "title": "The prices reflect the fare difference.",
          "description": "This applies if there are no seats available in your original booking class, if the route changes, or if ticket pricing conditions are no longer met."
        },
        "flexTicketDisclaimer": {
          "title": "Since you have a Flex ticket, ",
          "description": "if your new flight’s price is lower than the original, we will refund the difference."
        },
        "selectNewDates": {
          "plural": "Select the new dates for your flights",
          "singular": "Select the new date for your flight"
        }
      }
    },
    "ticketSelection": {
      "keepOriginalFlight": "Keep your original flight",
      "noChanges": "No changes",
      "priceDisclaimer": "Prices may vary based on availability, and our customer service can only offer the same ones shown here.",
      "flightsNotChangedModal": {
        "title": "Flights not changed",
        "returnToFlightSelect": "Back to flight options",
        "returnToBooking": "Go to Manage booking"
      }
    },
    "changeFlightsModal": {
      "title": "Change your flights"
    }
  }
}
